var map = {
	"./stocks.categories.js": "./src/router/admin/stocks.categories.js",
	"./stocks.feed-details.js": "./src/router/admin/stocks.feed-details.js",
	"./stocks.feeding-programs.js": "./src/router/admin/stocks.feeding-programs.js",
	"./stocks.units.js": "./src/router/admin/stocks.units.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/router/admin sync stocks(?!\\.route)\\.[a-z-]+(\\.js$)";